module.exports = __webpack_public_path__ + "static/media/rajesh.ee55d7b2.png";